export default __webpack_public_path__ + "static/media/forestly-expl-nn-base_EN.936f5104.png";